import { Component } from '@angular/core';
import { AppCommonModule } from "../../../../components/app.common.module";
import { environment } from 'environments/environment.local';
import { BaseComponent } from '@app/components/base/base.component';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';

@Component({
    selector: 'app-catalogs',
    standalone: true,
    templateUrl: './catalogs.component.html',
    styleUrl: './catalogs.component.css',
    imports: [AppCommonModule]
})
export class CatalogsComponent extends BaseComponent {
    isLoading: boolean = false;
    active_client_catalog: boolean = environment.active_client_catalog;
    readonly HIDE_DRM_REGION = environment.HIDE_DRM_REGION;
    module: string = '';

    constructor(
      private router: ActivatedRoute,
      private menu: MenusServices,
      notification: NotificationService,
    ) {
      super(router, menu, notification);
      this.module = this.sendDataToMenu();
    }
}


